<script>
import { HorizontalBar } from 'vue-chartjs'
import moment from 'moment'
export default {
    extends: HorizontalBar,
    data() {
        var dates = this.inspections;
        var labels = dates;
        var that = this;
        var series = _.keys(this.devices);
        if(this.orderby == 'number'){
            series = _.sortBy(_.keys(this.devices), function(c){
                return that.devices[c].dev_num;
            });
        }else if(this.orderby == 'conditions_asc'){
            series = _.sortBy(_.keys(this.devices), function(c){
                return dates[c];
            });
        }else if(this.orderby == 'conditions_desc'){
            series = _.reverse(_.sortBy(_.keys(this.devices), function(c){
                return dates[c];
            }));
        }
        var datas = _.map(series, (c) => { return _.reduce(_.values(_.mapValues(dates[c], 'conditions')), function(a,b){return a+b;}, 0.0) / (dates[c] || [null]).length });
        var avgs = _.zipObject(series, datas);
        var label = this.$t('routine_analyses.graphs.average');
        
        if(this.mode == 'stddev'){
            datas =  _.map(series, (c) => {
                var values = _.map(dates[c], 'conditions');
                var avg = _.sum(values) / values.length;
                var stdev = Math.sqrt(_.sum(_.map(values, (i) => (i - avg) * (i - avg))) / values.length);
                return stdev.toFixed(2) || ""
            });
            avgs = _.zipObject(series, datas);
            label = this.$t('routine_analyses.graphs.deviation');
        }
        return {
            chartData: {
                datasets: [{
                        axis: 'y',
                        label: label,
                        data: datas,
                        fill: false,
                        borderColor: that.color,
                        backgroundColor: that.color,
                        borderWidth: 1
                }],
                labels: _.map(series, (c) => { return that.devices[c].number; } )
            },
            options: {
                scales: {
                    yAxes: [{
                       ticks: {
                            stepSize: 1,
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            stepSize: 1,
                            beginAtZero: true,
                            max: 4
                        },
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    display: false
                },
                spanGaps: false,
                responsive: false,
                maintainAspectRatio: false
            }
        }
    },
    watch: {
        orderby: function (newInspections, oldInspections) {
            var dates = this.inspections;
            var labels = dates;
            var that = this;
            var series = _.keys(this.devices);
            var labels = _.map(_.sortBy(series, (c)=> { return dates[c] } ), (c) => { return that.devices[c].dev_num; } )
            var datas = _.map(series, (c) => { return _.reduce(_.values(_.mapValues(dates[c], 'conditions')), function(a,b){return a+b;}, 0.0) / (dates[c] || [null]).length });
            var avgs = _.zipObject(series, datas);
            var label = this.$t('routine_analyses.graphs.average');
            if(this.mode == 'stddev'){
                label = 'odchylenie';
                datas =  _.map(series, (c) => {
                    var values = _.map(dates[c], 'conditions');
                    var avg = _.sum(values) / values.length;
                    var stdev = Math.sqrt(_.sum(_.map(values, (i) => (i - avg) * (i - avg))) / values.length);
                    return stdev.toFixed(2) || ""
                })
                avgs = _.zipObject(series, datas);
            } 
            if(this.orderby == 'number'){
                labels = _.map(series, (c) => { return that.devices[c].number; } )
                datas = _.map(_.sortBy(_.keys(this.devices), function(c){
                    return that.devices[c].dev_num;
                }), function(c){
                    return avgs[c];
                });
            }else if(this.orderby == 'conditions_asc'){
                labels =  _.map( _.sortBy(series, function(c){
                    return avgs[c];
                }), (c) => { 
                    return that.devices[c].number;
                } )
                datas = _.map(_.sortBy(_.keys(this.devices), function(c){
                    return avgs[c];
                }), function(c){
                    return avgs[c];
                });
            }else if(this.orderby == 'conditions_desc'){
                labels =  _.reverse(_.map( _.sortBy(series, function(c){
                                return avgs[c];
                            }), (c) => { 
                                return that.devices[c].number;
                            } ))
                datas = _.reverse(_.map(_.sortBy(_.keys(this.devices), function(c){
                    return avgs[c];
                }), function(c){
                    return avgs[c];
                }));
            }
            this.chartData = {
                datasets: [{
                        axis: 'y',
                        label: label,
                        data: datas,
                        fill: false,
                         barThickness: 12,
                        maxBarThickness: 12,
                        borderColor: that.color,
                        backgroundColor: that.color,
                        borderWidth: 1
                }],
                labels: labels,
            }
            this.renderChart(this.chartData, this.options)
        }
    },
    props: {
        inspections: Object,
        devices: Object,
        color: String,
        orderby: String,
        mode: String
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>